export default __webpack_public_path__ + "static/media/logo.92781be9.svg";